@if (vista; as v) {
  <section class="detalle" [class.ajustada]="pantallaAncha()">
    <!-- Resumen: estado y lo más consultado. La identidad (identificación,
         nombre, cliente) está en el encabezado de la página. -->
    <app-dt-card>
      <app-dt-datos destacado>
        <app-dt-dato etiqueta="Estado" ocultarVacio>
          <app-dt-estado
            [tono]="v.conexion.tono"
            [etiqueta]="v.conexion.etiqueta"
          />
        </app-dt-dato>
        <app-dt-dato
          etiqueta="Último reporte"
          [valor]="v.hace ? 'hace ' + v.hace : null"
        >
          @if (v.hace) {
            <span class="dt-muted fecha">{{ v.ultimoReporte }}</span>
          }
        </app-dt-dato>
        <app-dt-dato
          etiqueta="Asignada a"
          [valor]="v.asignadaA ?? 'Sin asignar'"
        >
          @if (v.rutaActivo) {
            <a
              irxBotonIcono
              tamano="mini"
              [routerLink]="v.rutaActivo"
              tooltip="Ver detalle del activo"
            >
              <mat-icon>visibility</mat-icon>
            </a>
          }
        </app-dt-dato>
      </app-dt-datos>
    </app-dt-card>

    <div class="grilla">
      <div class="columna">
        <app-dt-card titulo="Dashcam" icono="label">
          <app-dt-datos>
            <app-dt-dato etiqueta="Marca y modelo" [valor]="v.marcaModelo" />
            <app-dt-dato
              etiqueta="ID único"
              [valor]="v.uniqueId"
              mono
              copiable
            />
            <app-dt-dato
              etiqueta="Número de serie"
              [valor]="v.numeroSerie"
              mono
              copiable
            />
            <app-dt-dato etiqueta="Estado de cuenta" [valor]="v.estadoCuenta" />
            <app-dt-dato
              etiqueta="Protocolo del modelo"
              [valor]="v.protocoloModelo"
            />
            <app-dt-dato
              etiqueta="Frecuencia de reporte"
              [valor]="v.frecuencia"
            />
          </app-dt-datos>
        </app-dt-card>

        <!-- Lo que la cámara informa de sí misma al conectarse: no se carga a
             mano, por eso no está en el formulario. -->
        <app-dt-card titulo="Equipo informado por la cámara" icono="memory">
          <app-dt-datos>
            <app-dt-dato etiqueta="Fabricante" [valor]="v.equipo.fabricante" />
            <app-dt-dato etiqueta="Modelo" [valor]="v.equipo.modelo" />
            <app-dt-dato
              etiqueta="IMEI"
              [valor]="v.equipo.imei"
              mono
              copiable
            />
            <app-dt-dato
              etiqueta="ID de terminal"
              [valor]="v.equipo.idTerminal"
              mono
              copiable
            />
            <app-dt-dato etiqueta="Firmware" [valor]="v.equipo.firmware" />
            <app-dt-dato
              etiqueta="Versión de protocolo"
              [valor]="v.equipo.versionProtocolo"
            />
            <app-dt-dato etiqueta="Registrada" [valor]="v.equipo.registro" />
          </app-dt-datos>
        </app-dt-card>

        <app-dt-card titulo="Video" icono="view_module">
          <app-dt-datos>
            @for (c of v.canales; track $index) {
              <app-dt-dato
                [etiqueta]="c.titulo"
                [valor]="c.habilitado ? c.detalle : 'Deshabilitado'"
              />
            } @empty {
              <app-dt-dato etiqueta="Canales" valor="Sin canales cargados" />
            }
            <app-dt-dato etiqueta="Calidad en vivo" [valor]="v.flujoEnVivo" />
            <app-dt-dato
              etiqueta="Corte automático en vivo"
              [valor]="v.corteEnVivo"
            />
            <app-dt-dato
              etiqueta="Evidencias automáticas"
              [valor]="v.evidencias"
            />
          </app-dt-datos>
        </app-dt-card>

        <app-dt-card titulo="SIMs" icono="sim_card">
          <app-dt-sims [sims]="v.sims" />
        </app-dt-card>
      </div>

      <!-- Mapa: ajustado a la pantalla, toma todo el alto de la columna. -->
      <div class="mapa" #contenedorMapa>
        <app-map-card
          [height]="pantallaAncha() && altoMapa() ? altoMapa() + 'px' : '320px'"
          [config]="mapCardConfig"
          [loading]="loadingMap()"
        ></app-map-card>
      </div>
    </div>
  </section>
} @else {
  <app-detalle-esqueleto soloCuerpo></app-detalle-esqueleto>
}
